import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import { selectStencilsType } from 'shared/product_tabs/tab_stencils/slice/selectors';

const getStencilImage = (stencilSlug) => {
  switch (stencilSlug) {
    case 'prototype-smt-stencils':
      return Spree.image_assets.prototype_smt_stencils;
    case 'framed-smt-stencils':
      return Spree.image_assets.framed_smt_stencils;
    case 'frameless-smt-stencils':
      return Spree.image_assets.frameless_smt_stencils;
    default:
      return '';
  }
};

const GeneralInformation = () => (
  <>
    <div className="stencil-description">
      <p className="m-0 general-description">
        <div className="price">
          {/* <img src={priceIco} alt="Price" /> */}
          Get 30% discount automatically on your Laser Cut SMT stencil with your PCBs
        </div>
        <div className="lead-time">
          {/* <img src={leadTimeIco} alt="Lead Time" /> */}
          SMT stencils ship in 24 hours.
        </div>
        <br />
        We use state-of-the-art laser technology which manufactures stencils <br />
        with smooth aperture walls and provides optimum solder paste volume control.
      </p>
    </div>
    <div className="d-flex align-items-center mb-3 select-paragraph">
      <FontAwesomeIcon
        style={{ color: '#267cd2' }}
        className="mb-1"
        icon="fa-solid fa-caret-right" />
      <h6 className="select-title mb-0">
        &nbsp;Please select a stencil type and stencil side(s)
      </h6>
    </div>
  </>
);

const ProductSelected = ({ product }) => {
  const regExp = /<li([\s\S]*?)<\/li>/g;
  const searched = product.description.match(regExp);
  const chunkSize = 2;
  const bullets = [];

  for (let i = 0; i < searched.length; i += chunkSize) {
    const chunk = searched.slice(i, i + chunkSize);
    bullets.push(chunk);
  }

  // const items = bullets.map((item) => `<ul>${item.join('')}</ul>`);

  return (
    <div className="stencil-description">
      <div className="row">
        <div className="col-12 col-lg-8">
          <h5 className="title">{product.name}</h5>
          <div className="lead-time">
            Lead Time: {product.lead_time}
          </div>
          <div className="price">
            Get 20% off on Laser Cut SMT Stencils with your PCBs
          </div>
          <div className="description">
            <div className="row">
              <div className="col-lg-auto">
                <ul>
                  {
                    // eslint-disable-next-line react/no-danger
                    searched.map((item, idx) => <li key={idx} dangerouslySetInnerHTML={{ __html: item }} />)
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-4 text-center">
          <img className="img-fluid" src={getStencilImage(product.slug)} alt={product.name} />
        </div>
      </div>
    </div>
  );
};

const ProductDescription = () => {
  let content;
  const stencilsType = useSelector(selectStencilsType);

  if (!stencilsType) {
    content = <GeneralInformation />;
  } else {
    const product = Spree.stencils_info.find((stencil) => stencil.slug === stencilsType);
    content = <ProductSelected product={product} />;
  }

  return (
    <>
      {content}
    </>
  );
};

ProductDescription.defaultProps = {};

export default ProductDescription;
